import { ProductDetailsEntity } from "@features/products/domain";
import {
  generateOptionsFromVariants,
  generateVariants,
} from "./generate-variants.mock";

export const productDetailsMock: ProductDetailsEntity = {
  // sku: "SA020601DF0099",
  // sku: "SA030202RSHA99",
  // id: "6720bbbf6abac322727fdada",
  id: "b1be36cc-464a-44f7-b8b2-88f0091c7fb4",
  categoryId: 1,
  options: generateOptionsFromVariants(generateVariants("123")),
  variants: generateVariants("123"),
};
